import { useSelector } from 'react-redux';
import { findPeerReconnecting } from './callStage';
/**
 * The partner pane's peer, when they left without hanging up and the server
 * holds the call for them to come back (the reconnect grace): the pane says
 * "reconnecting" rather than "waiting for" them. paneRole is the peer's role
 * (the interpreter pane for a client, the client pane for an interpreter).
 */
export function usePeerReconnecting(paneRole) {
    return useSelector((state) => findPeerReconnecting(state['features/vrs-layout'], paneRole));
}
